import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import Axios from '../../authorization/axiosInstance';

interface orderList {
    id: string,
    orderId: string,
    items: [
      {
        product: {
          id: string,
          productName: string,
          description: string,
          images: [
            {
              filePath: string
            }
          ]
        },
        variantDetails: {
          variant: {
            id: string,
            variantName: string
          },
          price: string
        },
        branch: {
          id: string,
          branchName: string,
          image: [
            {
              filePath: string
            }
          ],
          categoryTypes: [
            {
              id: string,
              name: string
            }
          ],
        },
        prdQty: number,
        prdPrice: string,
        totPrice: string
      }
    ],
    totItems: string,
    subTotalAmt: string,
    orderSts: string,
    paymentMode: string,
    paymentStatus: string,
    isCoupenApplied: boolean,
    coupenAmount: string,
    createdDate: string,
    review: {
      ratingCount: number,
      review: string
  }
}

interface orderListState {
  data: orderList[];
  loading: boolean;
  message: string;
  error: boolean;
  code: any ;
  size: any;
}

const initialState: orderListState = {
  data: [],
  loading: false,
  message: '',
  error: false,
  code: '',
  size:''
};

export const fetchOrders = createAsyncThunk<any, any>('orderList/fetchData', async (params, thunkAPI) => {
  return await Axios.get(`/orders`, { params: params }).catch(thunkAPI.rejectWithValue)
});

export const orderSlice = createSlice({
  name: 'orders',
  initialState,
  reducers: {
    clearState: (state) => {
      state.data = [];
      state.loading = false;
      state.message = '';
      state.error = false;
      state.code = '';
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOrders.pending, state => {
        state.loading = true;
        state.message = '';
        state.error = false;
      })
      .addCase(fetchOrders.fulfilled, (state, action: any) => {
        state.loading = false;
        state.code = action?.payload?.data?.code;
        state.data = action.payload?.data?.data;
        state.message = action?.payload?.data?.message;
        state.error = false;
        state.size = action.payload?.data?.count;
      })
      .addCase(fetchOrders.rejected, (state, action: any) => {
        state.loading = false;
        state.code = action?.payload?.response?.data?.code;
        state.message = action?.payload?.response?.data?.message || 'Something went wrong.';
        state.error = true;
      })
  },
});

export const { clearState } = orderSlice.actions;
export default orderSlice.reducer;
